/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      if (this.dataset.accessibleRemoveReady) return;
      this.dataset.accessibleRemoveReady = 'true';
      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');
      const item = this.closest('tr') || this.closest('.product-cart-item');
      const title = item?.querySelector('.cart-product-link')?.textContent.trim();
      this.setAttribute('aria-label', title ? 'Remove ' + title : 'Remove item');
      this.addEventListener('click', this.onClickHandler.bind(this));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          this.onClickHandler(event);
        }
      });
    }
    onClickHandler(event) {
      event.preventDefault();
      const index = this.dataset.index;
      const cartDrawer = this.closest('cart-drawer');
      if (cartDrawer) {
        cartDrawer.updateQuantity(index, '0');
      } else {
        document.dispatchEvent(new CustomEvent('cart:remove', { detail: { index } }));
      }
    }
  }
  customElements.define('cart-remove', CartRemove);
}
